<template>
  <Fragment>
    <VBanner
      v-if="vendor.branding.show_top_listener_banners"
      class="banner banner-top"
      dark
    >
      <div
        class="rte-content"
        v-html="vendor.branding.top_listener_banners"
      />
    </VBanner>

    <div class="flex-grow-1">
      <slot />
    </div>

    <VBanner
      v-if="vendor.branding.show_bottom_listener_banners"
      class="banner banner-bottom"
      dark
    >
      <div
        class="rte-content"
        v-html="vendor.branding.bottom_listener_banners"
      />
    </VBanner>
  </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment'
import { mapGetters } from 'vuex'
import * as getters from '@/store/getters/types'
import '@/assets/fonts/font-awesome/index.css'

export default {
  name: 'UBanner',

  components: {
    Fragment,
  },

  computed: {
    ...mapGetters({
      vendor: getters.VENDOR,
    }),
  },
}
</script>

<style lang="scss">
.banner-bottom {
  margin-top: 2rem;
}

.v-banner .v-banner__wrapper {
  padding: 0;
}
</style>
